<div class="widget-search">
    <form class="widget-search__body">
        <input class="widget-search__input" placeholder="Blog search..." type="text" autocomplete="off" spellcheck="false">
        <button class="widget-search__button" type="submit">
            <app-icon name="search-20" size="20"></app-icon>
        </button>
    </form>
</div>
